<template>
  <div :class="customClass || `p-4 border border-secondary rounded inline-flex items-center gap-[30px]`">
    <!-- Minus Button -->
    <button
      type="button"
      class="relative w-6 h-6 flex items-center justify-center before:content-[''] before:absolute before:inset-[-10px] before:z-[-1]"
      aria-label="Decrease quantity"
      @click="decrease"
    >
      <span class="block w-4 h-[4px] bg-secondary-2 z-10"></span>
      <span class="absolute inset-[-10px] z-0" aria-hidden="true"></span>
    </button>

    <!-- Quantity Display -->
    <span class="text-space-cadet text-[22px] leading-[30px]">{{ count }}</span>

    <!-- Plus Button -->
    <button
      type="button"
      class="w-6 h-6 flex items-center justify-center relative"
      aria-label="Increase quantity"
      @click="increase"
    >
      <span class="block w-4 h-[4px] bg-secondary-2 absolute z-10"></span>
      <span class="block w-[4px] h-4 bg-secondary-2 absolute z-10"></span>
      <span class="absolute inset-[-10px] z-0" aria-hidden="true"></span>
    </button>
  </div>
</template>

<script setup>
import { defineEmits, defineProps, ref, watch } from "vue";

const props = defineProps({
  modelValue: {
    type: Number,
    default: 1,
  },
  customClass: {
    type: String,
    default: null,
  },
});

const emit = defineEmits(["update:modelValue", "increment", "decrement"]);

const count = ref(props.modelValue);

// Watch external modelValue change (optional)
watch(
  () => props.modelValue,
  (newVal) => {
    count.value = newVal;
  }
);

function increase() {
  count.value++;
  emit("update:modelValue", count.value);
  emit("increment", count.value);
}

function decrease() {
  if (count.value > 0) {
    count.value--;
    emit("update:modelValue", count.value);
    emit("decrement", count.value);
  }
}
</script>
